const APPLICANT_TAB_KEY = 'mvp_applicant_tab_session';
const APPLICANT_LAST_ACTIVITY_KEY = 'mvp_applicant_last_activity_at';
const APPLICANT_MAX_IDLE_MS = 12 * 60 * 60 * 1000; // 12 hours

export function markApplicantSessionStarted(now = Date.now()) {
  try {
    sessionStorage.setItem(APPLICANT_TAB_KEY, '1');
    localStorage.setItem(APPLICANT_LAST_ACTIVITY_KEY, String(now));
  } catch {
    // ignore storage write errors
  }
}

export function touchApplicantActivity(now = Date.now()) {
  try {
    localStorage.setItem(APPLICANT_LAST_ACTIVITY_KEY, String(now));
  } catch {
    // ignore storage write errors
  }
}

export function hasApplicantTabSession() {
  try {
    return sessionStorage.getItem(APPLICANT_TAB_KEY) === '1';
  } catch {
    return false;
  }
}

export function isApplicantSessionIdleExpired(now = Date.now()) {
  try {
    const raw = localStorage.getItem(APPLICANT_LAST_ACTIVITY_KEY);
    const last = Number(raw);
    if (!Number.isFinite(last) || last <= 0) return true;
    return now - last > APPLICANT_MAX_IDLE_MS;
  } catch {
    return true;
  }
}

export function clearApplicantSessionArtifacts() {
  try {
    sessionStorage.removeItem(APPLICANT_TAB_KEY);
  } catch {
    // ignore
  }
  try {
    localStorage.removeItem(APPLICANT_LAST_ACTIVITY_KEY);
  } catch {
    // ignore
  }
}

export function clearApplicantAuthSession() {
  try {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
  } catch {
    // ignore
  }
  clearApplicantSessionArtifacts();
}
